import React from "react";
import Layout from "app/components/layouts";

import ContinueButton from "app/components/common/buttons/Continue";
import { useNavigate } from "react-router-dom";
import { openPrivacyPage } from "app/utils";
import WelcomePageImage from "app/assets/icons/WelcomePageImage";

const Welcome: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <Layout>
        <div className="w-[90%] sm:w-[40%] mx-auto text-center  sm:px-2 mt-8">
          <h1 className="font-Poppins text-[24px] sm:text-[40px] text-primary font-bold mb-4">
            Welcome To Hejaz
          </h1>
          <div className="text-center">
            <div className="flex items-center mb-4">
              <WelcomePageImage />
            </div>
            <p className="font-Mulish text-base text-[#98A2B3] text-center w-full sm:w-[85%] mx-auto mb-6">
              By continuing, you agree to our Terms of Use, including consent to
              receive and sign loan documents electronically. You also
              acknowledge and accept our{" "}
              <span
                className="text-gold cursor-pointer"
                onClick={openPrivacyPage}
              >
                Privacy Policy.
              </span>{" "}
            </p>
            <ContinueButton
              className="sm:!w-[70%] w-full  mx-auto"
              onClick={() => {
                navigate("/sign-in");
              }}
            >
              Continue
            </ContinueButton>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default Welcome;
